var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 45,
    viewBox: "0 0 66 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9817 13.7833V30.8767L63.5 42.5V2.5L49.9817 13.7833ZM5.50594 2.5H39.6659C44.6408 2.5 49.9444 6.51 49.9444 11.8433V39.1633C49.9535 40.0357 49.611 40.8761 48.9918 41.5008C48.3726 42.1254 47.5271 42.4835 46.6403 42.4967H11.4873C5.83806 42.4967 2.5 37.4967 2.5 32.4967L2.53389 5.83C2.46967 5.40883 2.49946 4.97896 2.62119 4.57026C2.74292 4.16157 2.95366 3.78384 3.23878 3.46333C3.51989 3.14637 3.86998 2.89577 4.26307 2.73015C4.65615 2.56453 5.08212 2.48814 5.50933 2.50667L5.50594 2.5Z",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.6b54990062f3560c854bb6818b6628a8.svg";
export { ForwardRef as ReactComponent };